import ApiService from "../api";

export default class EtapaConfiguracaoService extends ApiService {

    constructor() {
        super('/api/solicitacoes/config/etapas')
    }

    listarTodas() {
        return this.get(``)
    }

    salvar(tipoProcesso, dados) {
        return this.put(`/${tipoProcesso}`, dados)
    }
}
